import config from '@/app/editor/config/index';
import { app } from '@/store';

/**
 * ValidatorStatusCode
 * @param statusCode ..
 * @param url ..
 */
export const ValidatorStatusCode = (statusCode: number, url: string): undefined => {
  switch (statusCode) {
    case 404:
      if (config.isDev()) {
        // eslint-disable-next-line no-console
        console.error('Error: ', statusCode, url);
      } else {
        window.location.href = config.domain() + '/404.html';
      }
      break;
  }
  return;
};

type GemXHRType = {
  data?: any;
  dataType?: string;
  headers?: any;
  processData?: any;
  contentType?: any;
  beforeSend?: (xhr: any) => boolean | void;
};

type AjaxConfigType = {
  type: string;
  url: string;
  dataType: string;
  data?: any;
  headers?: any;
  processData?: any;
  contentType?: any;
  success: (data: any, status: any, xhr: any) => void;
  error: (data: any, status: any, xhr: any) => void;
  statusCode: any;
  xhrFields: any;
};

/**
 * gemXHR
 * @param method ..
 * @param url ..
 * @param gemXHRParams ..
 * @returns promise
 */
const gemXHR = function (method = 'GET', url: string, gemXHRParams: GemXHRType) {
  return new Promise((resolve, reject) => {
    let dataType = 'json';
    // let processData = true;
    // let contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

    if (gemXHRParams?.dataType) {
      dataType = gemXHRParams.dataType;
    }
    if (!/(http|ftp|ws)s{0,1}:\/\//.test(url)) {
      url = config.serverDomain() + url;
    }
    const gemSession = app.$store.getters['app/gemSession'] || '';
    let headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Gem-Session': gemSession
    };

    if (gemXHRParams?.headers) {
      headers = { ...headers, ...gemXHRParams.headers };
    }
    const ajaxConfigs: AjaxConfigType = {
      type: method,
      url: url,
      dataType: dataType,
      processData: gemXHRParams.processData,
      contentType: gemXHRParams.contentType,
      headers: headers,
      xhrFields: {
        withCredentials: true,
      },
      /**
       * success
       * @param data ..
       * @param status ..
       * @param xhr ..
       */
      success: function (data, status, xhr) {
        resolve({ data, status, xhr });
      },
      /**
       * error
       * @param xhr ..
       * @param status ..
       * @param error ..
       */
      error: function (xhr, status, error) {
        reject({ xhr, status, error });
      },
      statusCode: {
        /**
         * 404
         */
        404: function () {
          ValidatorStatusCode(404, url);
        },
      },
    };
    if (gemXHRParams?.data) {
      ajaxConfigs.data = gemXHRParams.data;
    }
    jQuery.ajax(ajaxConfigs);
  });
};

/**
 * GET
 * @param url string
 * @param data ..
 * @param type json or html
 * @param processData ..
 * @param contentType ..
 * @param beforeSend ..
 * @param headers ..
 * @returns promise
 */
export const GET = (
  url: string,
  data?: object,
  type?: string,
  processData: any = true,
  contentType: any = 'application/x-www-form-urlencoded; charset=UTF-8',
  beforeSend?: (xhr?: any) => boolean | void,
  headers?: any,
): Promise<any> => {
  const params: GemXHRType = {
    dataType: type,
    data: data,
  };
  if (typeof processData != 'undefined') {
    params.processData = processData;
  }
  if (typeof contentType != 'undefined') {
    params.contentType = contentType;
  }
  if (beforeSend) {
    params.beforeSend = beforeSend;
  }
  if (headers) {
    params.headers = headers;
  }
  return gemXHR('GET', url, params);
};

/**
 * POST
 * @param url string
 * @param data ..
 * @param type json or html
 * @param processData ..
 * @param contentType ..
 * @param beforeSend ..
 * @returns promise
 */
export const POST = (
  url: string,
  data: object,
  type?: string,
  processData: any = true,
  contentType: any = 'application/x-www-form-urlencoded; charset=UTF-8',
  beforeSend?: (xhr?: any) => boolean | void,
): Promise<any> => {
  const params: GemXHRType = {
    data: data,
    dataType: type,
  };
  if (typeof processData != 'undefined') {
    params.processData = processData;
  }
  if (typeof contentType != 'undefined') {
    params.contentType = contentType;
  }
  if (beforeSend) {
    params.beforeSend = beforeSend;
  }
  return gemXHR('POST', url, params);
};

/**
 * DELETE
 * @param url string
 * @param data ..
 * @param type json or html
 * @param processData ..
 * @param contentType ..
 * @param beforeSend ..
 * @returns promise
 */
export const DELETE = (
  url: string,
  data: object,
  type?: string,
  processData: any = true,
  contentType: any = 'application/x-www-form-urlencoded; charset=UTF-8',
  beforeSend?: (xhr?: any) => boolean | void,
): Promise<any> => {
  const params: GemXHRType = {
    data: data,
    dataType: type,
  };
  if (typeof processData != 'undefined') {
    params.processData = processData;
  }
  if (typeof contentType != 'undefined') {
    params.contentType = contentType;
  }
  if (beforeSend) {
    params.beforeSend = beforeSend;
  }
  return gemXHR('DELETE', url, params);
};

/**
 * PUT
 * @param url string
 * @param data ..
 * @param type json or html
 * @param processData ..
 * @param contentType ..
 * @param beforeSend ..
 * @returns promise
 */
export const PUT = (
  url: string,
  data: object,
  type?: string,
  processData: any = true,
  contentType: any = 'application/x-www-form-urlencoded; charset=UTF-8',
  beforeSend?: (xhr?: any) => boolean | void,
): Promise<any> => {
  const params: GemXHRType = {
    data: data,
    dataType: type,
  };
  if (typeof processData != 'undefined') {
    params.processData = processData;
  }
  if (typeof contentType != 'undefined') {
    params.contentType = contentType;
  }
  if (beforeSend) {
    params.beforeSend = beforeSend;
  }
  return gemXHR('PUT', url, params);
};
